export interface IUrlId {
  id: string;
}

export const toUrlId = (urlId: string) => ({ id: urlId });
